// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"order_wrapper__1wnIl","left":"order_left__cDyho"};